import React from 'react';
import QuickReports from './QuickReports';
import CampaignFilters from './filters/CampaignFilters';
import { QUICK_REPORTS_TYPES } from './consts';

const CampaignQuickReport = () => <QuickReports Filters={CampaignFilters} type={QUICK_REPORTS_TYPES.CAMPAIGN} />;

export default CampaignQuickReport;
